// import React, { useEffect, useState, useMemo } from "react";
// import classes from "./Section6.module.css";
// import ProductCard from "../../../components/ProductCard";
// import ProductCardSkeleton from "../../../components/ProductCardSkeleton";
// import API from "../../../utils/api";
// import SliderComp from "../../../components/SliderComp";

// export default function Section6() {
//   const [products, setProducts] = useState([]);
//   const [activeTab, setActiveTab] = useState("latest");
//   const [loading, setLoading] = useState(true);

//   const tabs = [
//     { key: "latest", label: "Latest Products" },
//     { key: "best", label: "Best Selling Products" },
//   ];

//   const getImageUrl = (imageName) => {
//     const baseUrl = API.base.endsWith("/serverstock_api")
//       ? API.base
//       : `${API.base}/serverstock_api`;
//     return imageName
//       ? `${baseUrl}/upload/${imageName}`
//       : `${baseUrl}/upload/placeholder-image.jpg`;
//   };

//   useEffect(() => {
//     let mounted = true;

//     async function fetchProducts() {
//       setLoading(true);
//       try {
//         const res = await fetch(`${API.base}/products.php`, {
//           method: "POST",
//           headers: { "Content-Type": "application/x-www-form-urlencoded" },
//           body: new URLSearchParams({ action: "fetch", status: "publish" }),
//         });
//         const data = await res.json();
//         const arr = Array.isArray(data) ? data : data.data || [];

//         const formatted = arr.map((p) => ({
//           ...p,
//           productImage: getImageUrl(p.productImage),
//           regularPrice: parseFloat(p.regularPrice) || 0,
//           salePrice: parseFloat(p.salePrice) || 0,
//           totalOrder: parseInt(p.totalOrder || 0),
//           created_at: p.created_at || "",
//         }));

//         if (mounted) setProducts(formatted);
//       } catch (err) {
//         console.error("Section6 Error:", err);
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     }

//     fetchProducts();
//     return () => {
//       mounted = false;
//     };
//   }, []);

//   const shuffleArray = (arr) => [...arr].sort(() => Math.random() - 0.5);

//   const filteredProducts = useMemo(() => {
//     if (!products.length) return [];

//     let filtered = [];

//     switch (activeTab) {
//       case "latest":
//         filtered = [...products].sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         );
//         break;
//       case "best":
//         filtered = [...products].sort((a, b) => b.totalOrder - a.totalOrder);
//         break;
//       default:
//         filtered = [...products];
//     }

//     return shuffleArray(filtered).slice(0, 8);
//   }, [activeTab, products]);

//   return (
//     <div className={classes.section6Wrapper}>
//       <div className={classes.section6Container}>
//         <h2>Featured Product</h2>
//         <div className={classes.tabsRow}>
//           {tabs.map((tab) => (
//             <button
//               key={tab.key}
//               className={`${classes.tabBtn} ${
//                 activeTab === tab.key ? classes.active : ""
//               }`}
//               onClick={() => setActiveTab(tab.key)}
//             >
//               {tab.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className={classes.productsCard}>
//         {loading ? (
//           <ProductCardSkeleton count={4} />
//         ) : filteredProducts.length > 0 ? (
//           <SliderComp>
//             {filteredProducts.map((p) => (
//               <div key={p.id} className={classes.sliderItem}>
//                 <ProductCard product={p} />
//               </div>
//             ))}
//           </SliderComp>
//         ) : (
//           <p className={classes.noProduct}>No products found for this tab.</p>
//         )}
//       </div>
//     </div>
//   );
// }

import { useEffect, useState, useMemo } from "react";
import ProductCard from "../../../components/ProductCard";
import ProductCardSkeleton from "../../../components/ProductCardSkeleton";
import SliderComp from "../../../components/SliderComp";
import API from "../../../utils/api";
import classes from "./Section6.module.css";

const CATEGORY_SLUGS = {
  latest: "network-switches",
  best: "amd-processors",
};

export default function Section6() {
  const [latestProducts, setLatestProducts] = useState([]);
  const [bestProducts, setBestProducts] = useState([]);
  const [activeTab, setActiveTab] = useState("latest");
  const [loading, setLoading] = useState(true);

  const tabs = [
    { key: "latest", label: "Latest Products" },
    { key: "best", label: "Best Selling Products" },
  ];

  const getImageUrl = (imageName) => {
    const baseUrl = API.base.endsWith("/serverstock_api")
      ? API.base
      : `${API.base}/serverstock_api`;
    return imageName
      ? `${baseUrl}/upload/${imageName}`
      : `${baseUrl}/upload/placeholder-image.jpg`;
  };

  const processProducts = (arr) => {
    return arr.map((p) => ({
      ...p,
      productImage: getImageUrl(p.productImage),
      regularPrice: parseFloat(p.regularPrice) || 0,
      salePrice: parseFloat(p.salePrice) || 0,
      totalOrder: parseInt(p.totalOrder || 0),
      created_at: p.created_at || "",
      categorySlug: p.category_slug || "",
    }));
  };

  const filterProductsByCategory = (
    products,
    slug,
    sortBy = "created_at",
    limit = 5
  ) => {
    return products
      .filter((p) => p.categorySlug === slug)
      .sort((a, b) =>
        sortBy === "totalOrder"
          ? b.totalOrder - a.totalOrder
          : new Date(b.created_at) - new Date(a.created_at)
      )
      .slice(0, limit);
  };

  useEffect(() => {
    let mounted = true;

    async function fetchProducts() {
      setLoading(true);
      try {
        const res = await fetch(`${API.base}/products.php`, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({ action: "fetch", status: "publish" }),
        });

        const data = await res.json();
        const arr = Array.isArray(data) ? data : data.data || [];
        const formatted = processProducts(arr);

        if (mounted) {
          setLatestProducts(
            filterProductsByCategory(formatted, CATEGORY_SLUGS.latest)
          );
          setBestProducts(
            filterProductsByCategory(
              formatted,
              CATEGORY_SLUGS.best,
              "totalOrder"
            )
          );
        }
      } catch (err) {
        console.error("Section6 Error:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchProducts();
    return () => {
      mounted = false;
    };
  }, []);

  const filteredProducts = useMemo(
    () => (activeTab === "latest" ? latestProducts : bestProducts),
    [activeTab, latestProducts, bestProducts]
  );

  return (
    <div className={classes.section6Wrapper}>
      <div className={classes.section6Container}>
        <h2>Featured Product</h2>
        {/* Tabs */}
        <div className={classes.tabsRow}>
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`${classes.tabBtn} ${
                activeTab === tab.key ? classes.active : ""
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Products Slider */}
      <div className={classes.productsCard}>
        {loading ? (
          <ProductCardSkeleton count={4} />
        ) : filteredProducts.length > 0 ? (
          <SliderComp>
            {filteredProducts.map((p) => (
              <div key={p.id} className={classes.sliderItem}>
                <ProductCard product={p} />
              </div>
            ))}
          </SliderComp>
        ) : (
          <p className={classes.noProduct}>No products found for this tab.</p>
        )}
      </div>
    </div>
  );
}
